import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import config from './config.js';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await fetch(`${config.backendUrl}/forgot_password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            setMessage(data.message);  //  Display the message from the server
        } catch (error) {
            console.error('An error occurred during password reset request:', error);
            setMessage("An error occurred. Please try again.");
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& .MuiTextField-root': { m: 1, width: '30ch' }
            }}
        >
            <Typography variant="h5" component="h2">
                Forgot Password
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                />
                <Button
                    type="submit"
                    variant="contained"
                    sx={{ mt: 2 }
                    } //  Add mt (margin-top) for spacing
                >
                    Submit
                </Button>
            </form>
            {message && <Typography variant="body1" sx={{ mt: 2 }}>{message}</Typography>}
            <Button
                variant="outlined" //  Use outlined style
                sx={{ mt: 2 }}      //  Add margin-top for spacing
                onClick={() => navigate('/login')}  //  <---  Handle the click
            >
                Cancel
            </Button>
        </Box>
    );
}

export default ForgotPassword;